export default __webpack_public_path__ + "img/rank2-65c9d070.png";